import { Field } from 'react-final-form';
import React from 'react';
import RadioAdapter from './RadioAdapter.jsx';

const CustomRadio = ({ checkedValue, options, action, name }) =>
  options.map(({ label, value }) => (
    <Field
      key={value}
      name={name}
      component={RadioAdapter}
      label={label}
      type="radio"
      value={value}
      checked={checkedValue === value}
      onChange={() => action(value)}
    />
  ));

export default CustomRadio;
